import { createAction } from 'redux-actions';
export var ADD_SELECTED_FARE = 'ADD_SELECTED_FARE';
export var SLICE_SELECTED_FARES = 'SLICE_SELECTED_FARES';
export var addSelectedFare = createAction(ADD_SELECTED_FARE, function (fare) { return fare; });
export var sliceSelectedFares = createAction(SLICE_SELECTED_FARES, function (legId) { return legId; });
